import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ProXSignService } from '../../../../services/pro-xsign-integration.service';
import { ValueAccessorBase } from '../../shared/value-accessor/value-accessor-base';

@Component({
  selector: 'pxs-base',
  imports: [],
  templateUrl: './pxs-base.component.html',
  styleUrl: './pxs-base.component.css',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: PxsBaseComponent, multi: true }
  ]
})
export class PxsBaseComponent extends ValueAccessorBase<string> implements OnInit, AfterViewInit {

  public proXSignService = inject(ProXSignService); // Inject only in child component
  public proXSignLib:any;

  super(): void {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
  }
}
